"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.default = void 0;

function get(object, accessorFn, defaultValue) {
  try {
    const result = accessorFn(object);
    return result === undefined || result === null ? defaultValue : result;
  } catch (e) {
    return defaultValue;
  }
}

var _default = get;
exports.default = _default;
